import Vue from 'vue'
import TxtPreview from './txtPreview.vue'

const MyTxtPreview = Vue.extend(TxtPreview)

TxtPreview.install = (Vue) => {
  return Vue.prototype.$TxtPreview = (options) => {
    let { content, url } = options
    let instance = new MyTxtPreview({
      data: {
        content,
        url,
      },
    }).$mount()
  
    document.body.appendChild(instance.$el)

    return instance.init()
  }
}

export default TxtPreview